import React, { useRef, useContext } from 'react'
import PopoverMenu from 'js/components/ui/PopoverMenu.js';
import IconButton from '@mui/material/IconButton';
import { Link, useNavigate } from "react-router-dom";
import AppContext from 'js/Contexts/App.js';
import { produce } from 'immer';
import 'scss/components/page-components/Layout/Navbar/AppsDropdown.scss';
import { useTranslate2 } from 'js/components/helpers/Translate.js';

const AppsDropdown = (props) => {
    const appContext = useContext(AppContext);
    const triggerRef = useRef();
    const navigate = useNavigate();
    let currentUser = appContext.authService.getCurrentIdentity()?.user;
    const currentAccount = appContext.appReducer.getCurrentAccountWithData();
    
    const { layoutTranslations } = appContext;
    const translate = useTranslate2(layoutTranslations?.translations || {});
    
    const closeDropDown = () => {
        appContext.setMainLayoutState(produce(appContext.mainLayoutState, draft => {
            draft.appsDropdownOpen = false;
        }));
    };

    const handleAppClick = (path) => {
        closeDropDown();
        navigate(path);
    };

    return (
        <div className="L_Navbar_AppsDropdown">
            <div className="menuTrigger" ref={triggerRef} onClick={() => {
                appContext.setMainLayoutState(produce(appContext.mainLayoutState, draft => {
                    draft.appsDropdownOpen = !appContext.mainLayoutState.appsDropdownOpen;
                }));
            }}>
                <IconButton aria-label="apps" size="small">
                    <img className='appsIcon' src="/icon/layout/apps-icon.svg" />
                </IconButton>
            </div>
            
            {appContext.mainLayoutState.appsDropdownOpen &&
                <PopoverMenu onClose={closeDropDown} className="L_Navbar_AppsMenu" open={true} anchorEl={triggerRef.current} placement={'bottom-start'}>
                    <div className="appsDropdownHeader">
                        <h2>ORDERCOLLAB</h2>
                        <div className="appsSubtitle">
                            <img src="/icon/layout/apps-icon.svg" className="appsHeaderIcon" />
                            <span>Apps</span>
                        </div>
                    </div>
                    
                    <div className="appsContainer">
                        {currentUser && currentAccount && (
                            <>
                                <div className="appCard active" onClick={() => handleAppClick(`/a/ac/${currentAccount.id}/sample-approvals`)}>
                                    <div className="appIconContainer">
                                        <img src="/img/logos/sample-approvals-logo.png" className="appLogo" />
                                    </div>
                                    <div className="appInfo">
                                        <h3>Sample Approvals</h3>
                                        <p>{translate('Navbar.SampleApprovalsAppDescription')}</p>
                                    </div>
                                </div>
                                
                            </>
                        )}
                    </div>
                </PopoverMenu>
            }
        </div>
    )
}

export default AppsDropdown